import { Link } from "react-router-dom";

const footerLinks = [
  { label: "Inicio", href: "/" },
  { label: "Servicios", href: "/servicios" },
  { label: "Colaboradores", href: "/colaboradores" },
  { label: "Blog", href: "/blog" },
  { label: "Contacto", href: "/#contacto" },
];

const legalLinks = [
  { label: "Política de privacidad", href: "/privacidad" },
  { label: "Aviso legal", href: "/aviso-legal" },
  { label: "Política de cookies", href: "/cookies" },
];

export default function Footer() {
  const handleAnchorClick = (href: string) => {
    if (href.startsWith("/#")) {
      const id = href.replace("/#", "");
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer style={{ backgroundColor: "#1A1A1A" }} className="text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        {/* Top grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://static.readdy.ai/image/b4936df4b10639d97e7d05f0664429e8/be965cfe45c65ed2ba19741b88263b64.png"
              alt="Fair Play Global"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-brand-gray-mid text-sm font-body leading-relaxed max-w-sm">
              Gestión integral de ligas y competiciones amateurs. Tu partner externo profesional en gestión deportiva, administrativa y fiscal.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-brand-red hover:text-brand-red transition-colors cursor-pointer"
                aria-label="Instagram Fair Play Global"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 hover:border-brand-red hover:text-brand-red transition-colors cursor-pointer"
                aria-label="LinkedIn Fair Play Global"
              >
                <i className="ri-linkedin-line text-base"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-white text-base font-bold tracking-wide uppercase mb-5">
              <a href="/servicios">Navegación</a>
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  {link.href.startsWith("/#") ? (
                    <button
                      onClick={() => handleAnchorClick(link.href)}
                      className="text-brand-gray-mid hover:text-brand-red text-sm font-body transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </button>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-brand-gray-mid hover:text-brand-red text-sm font-body transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-white text-base font-bold tracking-wide uppercase mb-5">
              <a href="/#contacto">Contacto</a>
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-brand-gray-mid text-sm font-body">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-mail-line text-brand-red text-sm"></i>
                </div>
                <span>info@fairplayglobal.es</span>
              </li>
              <li className="flex items-start gap-2 text-brand-gray-mid text-sm font-body">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-phone-line text-brand-red text-sm"></i>
                </div>
                <span>+34 658 30 61 63</span>
              </li>
              <li className="flex items-start gap-2 text-brand-gray-mid text-sm font-body">
                <div className="w-4 h-4 flex items-center justify-center mt-0.5">
                  <i className="ri-time-line text-brand-red text-sm"></i>
                </div>
                <span>Lun–Vie: 9:00–18:00</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-brand-gray-mid text-xs font-body">
            &copy; {new Date().getFullYear()} Fair Play Global. Todos los derechos reservados.
          </p>
          <div className="flex items-center gap-6">
            {legalLinks.map((link) => (
              <Link
                key={link.label}
                to={link.href}
                className="text-brand-gray-mid hover:text-brand-red text-xs font-body transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}